<script setup lang="ts">
  const { t } = useI18n()
</script>

<template>
  <a
    href="#main-content"
    class="absolute -left-full top-2 z-50 -translate-x-20 rounded bg-bt-green px-4 py-2 font-medium text-bt-blue-dark no-underline opacity-0 focus:left-1/2 focus:bg-bt-green-hover focus:opacity-100"
  >
    {{ t('skipToContent') }}
  </a>
</template>
